import moment from 'moment';


const sortByTitle = (cards, list) => {
  const sortedList = [...list];
  return sortedList.sort((a, b) => {
    const aTitle = cards[a] ? cards[a].title : '';
    const bTitle = cards[b] ? cards[b].title : '';
    if (aTitle < bTitle) {
      return -1;
    }
    if (aTitle > bTitle) {
      return 1;
    }
    return 0;
  });
};


const getRandomId = (set) => {
  const randomIndex = Math.floor(Math.random() * set.length);
  return set[randomIndex];
};


// Day starts at 3:00am so night card goes until late
const isToday = (timeString) => {
  if (!timeString) {
    return false;
  }
  const time = moment(timeString);
  const startOfDay = moment();
  if (startOfDay.hour() < 3) {
    startOfDay.subtract(1, 'day');
  }
  startOfDay.hour(3).minute(0).seconds(0);
  return time.isAfter(startOfDay);
};


const sluggify = string => (
  string.toLowerCase()
    .replace(/[^0-9a-zA-Z -]/g, '')
    .trim()
    .replace(/ +/g, '-')
);
// console.log(sluggify("Unicorns & Rain-bow's!  "));


const trimParagraphs = text => (
  text.trim()
    .split('\n')
    .map(p => p.trim())
    .join('\n')
);


const getUpdateMaskQuery = (fields) => {
  let query = '';
  fields.forEach((field) => {
    query = `${query}&updateMask.fieldPaths=${field}`;
  });
  return `?${query.substring(1)}`;
};

// ** No longer using ** - just generating single random id each day
// Daily cards should be shuffled in a way that
// doesn't lead to getting the same card within a few days
// percentBetween = minimum percent of indexes between the same card if the two arrays were combined

// const shuffleDailyCards = (originalArray) => {
//   const array = [...originalArray];
//   const percentBetween = 0.4;
//   const numBetween = Math.floor(array.length * percentBetween);
//   for (let i = 0; i < array.length - 2; i++) {
//     const maxLength = (array.length) - Math.max(numBetween - i, 0);
//     const randomIndex = Math.floor((Math.random() * (maxLength - i)) + i);
//     const temp = array[i];
//     array[i] = array[randomIndex];
//     array[randomIndex] = temp;
//   }
//   return array;
// };

export {
  sortByTitle,
  getRandomId,
  isToday,
  sluggify,
  trimParagraphs,
  getUpdateMaskQuery,
};
